import { AutoAwesomeOutlined } from "@mui/icons-material";
import { Button, Typography } from "@mui/material";
import { ShineBorder } from "src/components/ShineBorder/ShineBorder";

export const GeneratedByAIBadge = ({
  scrollToElement,
}: {
  scrollToElement: () => void;
}) => {
  return (
    <div className="relative flex rounded-xl justify-between items-center border border-gray-200 shadow-md border-solid p-2 px-4 gap-x-2 w-fit animate-fade-down animate-delay-750">
      <ShineBorder />
      <div className="flex items-center gap-x-2">
        <AutoAwesomeOutlined className="w-6 h-6 text-color-primary-darkest" />
        <Typography variant="body2" className="text-black">
          Inputs were AI generated from your website. Please check for errors.
        </Typography>
      </div>
      <Button
        variant="text"
        color="primary"
        size="small"
        className="ml-2"
        onClick={scrollToElement}
      >
        Jump to Create Device
      </Button>
    </div>
  );
};
